import styles from './ContentPanes.module.scss'
import {Text } from '@mantine/core';
import Image, { StaticImageData } from 'next/image';
import Link from 'next/link';
import imageOnline from '../images/my-account/upcoming_250px.png'
import imageSearchVideos from '../images/my-account/video_search_250px.png'
import imageSearchImages from '../images/my-account/image_search_250px.png'
import image3dlibrary from '../images/my-account/3d_250px.png'
import imageGoodies from '../images/my-account/additional_benefits_250px.png'
import imageSettings from '../images/my-account/subscription_details_250px.png'
import imageSubscription from '../images/my-account/subscription_250px.png'
import imagePlaylist from '../images/my-account/playlist.png'
import imageUserImages from '../images/my-account/user_images_250.png'

import { Price } from './Localization';

interface PaneProps {
    img:StaticImageData,
    link:string,
    title:string,
    children: JSX.Element,
    priority?: boolean,
}

export enum ContentPaneTypes
{
    onlineSessions,
    videoSearch,
    imageSearch,
    threeDLibrary,
    accountSettings,
    discounts,
    subscribeNow,
    overviewVideo,
    playlists,
    userImages
}

interface ContentPanesProps
{
    contentPanes : ContentPaneTypes []
}

export default function ContentPanes(props : ContentPanesProps)
{
return (
    <div className={styles.paneCollection}>
    {props.contentPanes.some(x=> x== ContentPaneTypes.onlineSessions) && <Pane key='online' title="Upcoming online sessions" img={imageOnline} link='/upcoming-online-sessions' priority><Text>We run regular, tutored <Link href='/upcoming-online-sessions'>online drawing sessions</Link>. They&rsquo;re a great way to carve out a time to focus on your art each week. </Text></Pane>}
    {props.contentPanes.some(x=> x== ContentPaneTypes.videoSearch) && <Pane key='videosearch' title="Video search" img={imageSearchVideos} link='/new-video-search'><Text>Missed a session? Or want to find a session based on its subject matter, tutor or materials used? You can search our library of hundreds of portrait, figure, landscape and still lifes <Link href='/new-video-search'>here</Link></Text></Pane>}
    {props.contentPanes.some(x=> x== ContentPaneTypes.playlists) && <Pane key='playlists' title="Playlists" img={imagePlaylist} link='/playlists'><Text>Take a look of our curated playlists, carefully selected for our library of hundreds of videos. Click <Link href='/playlists'>here</Link></Text></Pane>}

    {props.contentPanes.some(x=> x== ContentPaneTypes.imageSearch) && <Pane key='image' title="Image search" img={imageSearchImages} link='/image-search'><Text>Looking for a reference photo? Search our library of 1,200+ images by model type, pose and so on <Link href='/image-search'>here</Link></Text></Pane>}
    {props.contentPanes.some(x=> x== ContentPaneTypes.threeDLibrary) && <Pane key='threed' title="3D library" img={image3dlibrary} link='/3d-models'><Text>We have a number of 3d reference models too – you can view annotated, anatomical sculptures and real people in three dimensions. Go <Link href='/3d-models'>here</Link></Text></Pane>}

    {props.contentPanes.some(x=> x== ContentPaneTypes.userImages) && <Pane key='userimages' title="Share your work" img={imageUserImages} link='/user-images'><Text>You can share your work from our sessions and reference libraries, and see other people&rsquo;s too. Go <Link href='/user-images'>here</Link></Text></Pane>}
    

    {props.contentPanes.some(x=> x== ContentPaneTypes.discounts) && <Pane key='goodies' title="Additional subscriber benefits" img={imageGoodies} link='/additional-subscriber-benefits'><Text>We&rsquo;ve negotiated discounts and special offers with third parties. Go <Link href='/additional-subscriber-benefits'>here</Link> for more details.</Text></Pane>}
    {props.contentPanes.some(x=> x== ContentPaneTypes.subscribeNow) && <Pane key='subscribe' title="Subscribe now" img={imageSubscription} link='/raw-umber-subscription'><Text>Like what you&rsquo;ve seen so far? Then <Link href='/raw-umber-subscription'>subscribe</Link> from only <Price gbp={5}/> a month.</Text></Pane>}
    {props.contentPanes.some(x=> x== ContentPaneTypes.accountSettings) && 
            <>
            <Pane key='settings' title="Account settings" img={imageSettings} link='/account-information'><><Text>If you want to update your payment details, cancel, upgrade or downgrade your subscription, change your password, or upload a profile picture, then go <Link href='/account-information'>here</Link>.</Text>
            <Text>To log out of your account, click <Link href='/log-out'>here</Link>.</Text></></Pane></>            
        }


</div>

);
}

function Pane(props: PaneProps)
{
        return <div className={styles.pane}>
                <div className={styles.paneImage}>

                {props.img &&
                <Link href={props.link}>
                    <Image src={props.img} alt={props.title} width={250} height={250} priority={props.priority}></Image>
                </Link>}
               
                </div>
                <div className={styles.paneBlock}>{props.children}</div>
                </div>

}
